import React from "react";
import { ModeRendererProps } from "./types";

// VASARELY × BOTTEGA VENETA: Invisible branding
// Intrecciato pattern, soft geometry, neutral tones
export function VasarelyBottegaMode({ brand }: ModeRendererProps) {
  const bvBrown = "#8B7355";
  const bvBeige = "#D4C5B9";

  return (
    <g>
      {/* Subtle background */}
      <defs>
        <linearGradient id="bottega-leather" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#E8DED2" />
          <stop offset="100%" stopColor="#D4C5B9" />
        </linearGradient>
      </defs>

      <rect x="0" y="0" width="794" height="1123" fill="url(#bottega-leather)" />

      <g transform="translate(397 540)">
        {/* Intrecciato weave pattern */}
        {Array.from({ length: 18 }).map((_, i) =>
          Array.from({ length: 24 }).map((_, j) => {
            const x = (i - 8.5) * 36;
            const y = (j - 11.5) * 34;
            const horizontal = (i + j) % 2 === 0;
            
            return (
              <rect
                key={`${i}-${j}`}
                x={horizontal ? x - 16 : x - 4}
                y={horizontal ? y - 4 : y - 16}
                width={horizontal ? 32 : 8}
                height={horizontal ? 8 : 32}
                fill={bvBrown}
                opacity="0.3"
              />
            );
          })
        )}

        {/* Soft geometry (subtle curves) */}
        {Array.from({ length: 10 }).map((_, i) => {
          const y = -200 + i * 44;
          const points = Array.from({ length: 40 }).map((_, j) => {
            const x = -280 + j * 14;
            const curve = Math.sin(j * 0.2) * 15;
            return `${x},${y + curve}`;
          }).join(" ");
          
          return (
            <polyline
              key={i}
              points={points}
              fill="none"
              stroke={bvBrown}
              strokeWidth="2"
              opacity="0.25"
            />
          );
        })}

        {/* Invisible branding circles */}
        {Array.from({ length: 16 }).map((_, i) => {
          const r = 40 + i * 15;
          return (
            <circle
              key={i}
              cx="0"
              cy="0"
              r={r}
              fill="none"
              stroke={bvBrown}
              strokeWidth="1"
              opacity={0.25 - i * 0.014}
            />
          );
        })}

        {/* Craft nodes (artisanal precision) */}
        {[0, 72, 144, 216, 288].map((angle) => {
          const rad = (angle * Math.PI) / 180;
          const r = 190;
          
          return (
            <g key={angle}>
              <circle
                cx={Math.cos(rad) * r}
                cy={Math.sin(rad) * r}
                r="20"
                fill={bvBeige}
                opacity="0.5"
              />
              <circle
                cx={Math.cos(rad) * r}
                cy={Math.sin(rad) * r}
                r="20"
                fill="none"
                stroke={bvBrown}
                strokeWidth="2"
                opacity="0.6"
              />
            </g>
          );
        })}

        {/* Woven trust lines */}
        {Array.from({ length: 24 }).map((_, i) => {
          const angle = (i * Math.PI) / 12;
          return (
            <line
              key={i}
              x1="0"
              y1="0"
              x2={Math.cos(angle) * 230}
              y2={Math.sin(angle) * 230}
              stroke={bvBrown}
              strokeWidth="1"
              opacity="0.15"
              strokeDasharray="6 6"
            />
          );
        })}

        {/* Central medallion (subtle sophistication) */}
        <circle cx="0" cy="0" r="70" fill={bvBeige} opacity="0.4" />
        <circle cx="0" cy="0" r="70" fill="none" stroke={bvBrown} strokeWidth="2" opacity="0.6" />
        <circle cx="0" cy="0" r="60" fill="none" stroke={bvBrown} strokeWidth="1" opacity="0.4" />
        
        {/* Intrecciato center */}
        {[-30, -10, 10, 30].map((offset) => (
          <React.Fragment key={offset}>
            <rect x={offset - 3} y="-40" width="6" height="80" fill={bvBrown} opacity="0.5" />
            <rect x="-40" y={offset - 3} width="80" height="6" fill={bvBrown} opacity="0.5" />
          </React.Fragment>
        ))}
      </g>

      {/* Bottega Veneta text */}
      <text x="397" y="1010" textAnchor="middle" fontFamily="serif" fontSize="11" fill={bvBrown} opacity="0.7" fontStyle="italic">
        branding invisible
      </text>
    </g>
  );
}
